import React from 'react';
import { StyledEngineProvider } from '@mui/material/styles';

interface Props {
  children?: React.ReactNode;
}

const StyleProvider: React.FC<Props> = ({ children }) => (
  <StyledEngineProvider injectFirst>{children}</StyledEngineProvider>
);

export default StyleProvider;
